var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('index', 'office_visit'))?_c('router-link',{attrs:{"to":"/insurance-office-visit/table"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":href},on:{"click":navigate}},[_c('i',{staticClass:"menu-icon flaticon2-cardiogram"}),_c('span',{staticClass:"menu-text"},[_vm._v("Office Visit")])])])]}}],null,false,2168668720)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }